export enum DepartmentType {
    Tech = 'TECH',
    CustomerCare = 'CUSTOMER_CARE',
    Management = 'MANAGEMENT'
}
